module.exports = __webpack_public_path__ + "static/media/GS.5cd2177f.webp";